import React from "react";
import { Menus } from "./components/Menus";
import { MenuIcon } from "../common/icons/MenuIcon";
import { MobileSideMenu } from "../side_menu/MobileSideMenu";
import { GlobalHeaderProps } from "./GlobalHeader";
import { useBoolean } from "../../hooks/common/useBoolean";

export const MobileHeader = React.memo(function MobileHeader(props: GlobalHeaderProps) {
    const { withSideMenu } = props;

    const [openSideMenu, setSlideOpen, setSlideClose, ] = useBoolean();

    return (
        <div className={"global_header"}>
            {/* タイトル */}
            <div className={"global_header__title"}>
                <div className={"burger_menu"} onClick={setSlideOpen}>
                    <MenuIcon />
                </div>
            </div>
            {/* メニュー */}
            <Menus />
            {/* サイドメニュー */}
            <MobileSideMenu
                withSideMenuContent={withSideMenu}
                isOpenSlide={openSideMenu}
                handleSlideOpen={setSlideOpen}
                handleSlideClose={setSlideClose}
            />
        </div>
    );
});
